import { createPopper } from '@popperjs/core';

export default function (element) {
    const button = element.querySelector('.date-switcher__action');
    const popover = element.querySelector('.date-switcher__menu');

    createPopper(button, popover, {
        placement: 'bottom-start',
        modifiers: [
            {
                name: 'sameWidth',
                enabled: true,
                fn: ({ state }) => {
                    state.styles.popper.width = `${state.rects.reference.width}px`;
                },
                phase: 'beforeWrite',
                requires: ['computeStyles'],
                effect: ({ state }) => {
                    state.elements.popper.style.width = `${state.elements.reference.clientWidth}px`;
                },
            },
            {
                name: 'offset',
                options: {
                    offset: ({ placement }) => {
                        if (placement === 'bottom') {
                            return [0, button.offsetHeight];
                        }

                        return [0, -button.offsetHeight];
                    },
                },
            },
        ],
    });
}
